(function () {
  'use strict';
  function validate(action = {}) {
    let returnable;
    if (
      angular.isString(action.vendorId) &&
      angular.isObject(action.product) &&
      angular.isString(action.product.displayName) &&
      angular.isNumber(action.product.price) &&
      angular.isString(action.product.categoryId)
    ) {
      returnable = true;
    }
    return returnable;
  }
  function reducer(action, $firedux) {
    let uid = $firedux.var('UID');
    return $firedux
      .ref('products')
      .child(uid)
      .child('metadata')
      .set({
        isApproved: true,
        vendorId: action.vendorId,
        teamId: action.teamId || null,
        displayName: action.product.displayName,
        price: action.product.price,
        categoryId: action.product.categoryId,
        display: action.product.display || null,
        caseCount: action.product.caseCount || null,
        unitsPerSite: action.product.unitsPerSite || null,
        distributorPrice: action.product.distributorPrice || null,
        marketing: action.product.marketing || null,
        tiers: action.product.tiers || null,
        notes: angular.isString(action.product.notes) ? action.product.notes : null
      })
      .then(() => {
        return new Promise((resolve, reject) => {
          $firedux
            .ref('products')
            .child(uid)
            .child('metadata')
            .child('isApproved')
            .on('value', (snap) => {
              const isApproved = snap.val();
              if (isApproved) {
                resolve(uid);
              }
            }, reject);
        });
      });
  }
  angular
    .module('reducers')
    .run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'PRODUCT.ADD',
      reducer: function (action) {
        return validate(action) ?
          reducer(action, $firedux) :
          Promise.reject('VALIDATION ERROR');
      }
    });
  }
}());
